import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._b({attrs:{"loading":_vm.loading,"color":"primary","depressed":""},on:{"click":function($event){$event.preventDefault();return _vm.checkoutHandler.apply(null, arguments)}}},'v-btn',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.$t('Checkout'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }